import { IconX } from '@tabler/icons-react'
import { classNames } from 'util/classNames'

export type PillColorType =
  | 'red'
  | 'rose'
  | 'yellow'
  | 'purple'
  | 'pink'
  | 'black'
  | 'green'
  | 'gray'
  | 'blue'
  | 'teal'
  | 'indigo'
  | 'orange'

export const Pill = ({
  children,
  color,
  onClose,
  onClick,
  className,
  hasMaxWidth = true,
  hasPadding = true,
  style,
}: {
  children: any
  className?: string
  hasMaxWidth?: boolean
  hasPadding?: boolean
  color: PillColorType
  style?: React.CSSProperties
  onClose?: (e: React.MouseEvent<SVGSVGElement, MouseEvent>) => void
  onClick?: (e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => void
}) => {
  const getStyle = () => {
    switch (color) {
      case 'red':
        return 'bg-red-50 text-red-700 ring-red-600/20'
      case 'rose':
        return 'bg-rose-50 text-rose-700 ring-rose-600/20'
      case 'yellow':
        return 'bg-yellow-50 text-yellow-700 ring-yellow-600/20'
      case 'purple':
        return 'bg-purple-50 text-purple-700 ring-purple-600/20'
      case 'pink':
        return 'bg-pink-50 text-pink-700 ring-pink-600/20'
      case 'black':
        return 'bg-gray-50 text-gray-700 ring-gray-600/20'
      case 'green':
        return 'bg-green-50 text-green-700 ring-green-600/20'
      case 'gray':
        return 'bg-gray-50 text-gray-700 ring-gray-600/20'
      case 'blue':
        return 'bg-toasty-blue-50 text-blue-700 ring-blue-600/20'
      case 'teal':
        return 'bg-teal-50 text-teal-700 ring-teal-600/20'
      case 'indigo':
        return 'bg-indigo-50 text-indigo-700 ring-indigo-600/20'
      case 'orange':
        return 'bg-orange-50 text-orange-700 ring-orange-600/20'
      default:
        return 'bg-gray-50 text-gray-700 ring-gray-600/20'
    }
  }

  return (
    <div className="max-w-full">
      <span
        onClick={onClick}
        className={classNames(
          `mr-1 inline-flex items-center justify-center rounded-3xl px-2 py-1 text-center text-[10px] font-medium ring-1 ring-inset ${getStyle()} ${
            hasMaxWidth
              ? 'max-w-[128px]'
              : 'max-w-full overflow-ellipsis whitespace-nowrap'
          }`,
          className,
          'w-full'
        )}
        style={{ display: 'flex', alignItems: 'center', ...style }}
      >
        <span className="flex-grow overflow-hidden text-ellipsis whitespace-nowrap">
          {children}
        </span>
        {onClose && (
          <IconX
            size={8}
            className="ml-1 flex-shrink-0 cursor-pointer"
            onClick={onClose}
          />
        )}
      </span>
    </div>
  )
}
